import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: 100,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      overFlow: 'hidden'
    },
    small: {
      width: '450px'
    },
    medium: {
      width: '700px'
    },
    cover: {
      width: '90%'
    },
    laptop: {
      paddingLeft: '240px',
      width: '90%'
    },
    container: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      marginLeft: 'auto',
      marginRight: 'auto',
      animation: `$apparition 800ms ease-in-out`,
      overflowX: 'hidden',
      maxHeight: '98vh',
      overFlowY: 'scroll',
      '@media (max-width: 768px)': {
        width: '90%'
      },
      '@media (min-width: 769px) and (max-width: 1280px)': {
        paddingLeft: '240px',
        width: '90%'
      }
    },
    '@keyframes apparition': {
      '0%': {
        top: '200vh'
      },
      '80%': {
        top: '40%'
      },
      '100%': {
        top: '50%'
      }
    },
    modalHead: {
      position: 'absolute',
      top: '15px',
      left: '50%',
      transform: 'translate(-50%, 0)',
      marginLeft: 'auto',
      marginRight: 'auto',
      whiteSpace: 'nowrap'
    },
    buttonModalChallenge: {
      '@media (max-width: 500px)': {
        width: '-webkit-fill-available'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
